import { gql } from '@apollo/client'

export const UPSERT_ADMIN_SETTING = gql`
  mutation upsertAdminSetting($input: UpsertAdminSettingInput!) {
    upsertAdminSetting(input: $input) {
      key
      value
      updatedAt
      updatedBy
    }
  }
`
